import { Box, Button, TextField } from "@mui/material";
import React, { useState } from "react";
import { SendButtonIcon } from "../../../assets/icons/MUI/ChatIcons";
import { useParams } from "react-router-dom";
import { sendMessage } from "../firestore";
import { useQuery } from "@tanstack/react-query";
import { EntityInfo } from "../../../types";
import { useTranslation } from "react-i18next";

type ChatInputProps = {
  scrollContainerRef: React.MutableRefObject<HTMLDivElement | null>; // Accept scrollContainerRef as prop
};

const ChatInput = ({ scrollContainerRef }: ChatInputProps) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const [message, setMessage] = useState("");
  const { chatId } = useParams<{ chatId: string }>();

  const { data: userInfo = {} } = useQuery<EntityInfo>({
    queryKey: ["userInfo"],
    enabled: false,
  });

  const handleSendMessage = () => {
    if (!chatId || !userInfo?.id || message.trim() === "") return;

    sendMessage(chatId, message, userInfo.id);
    setMessage("");

    setTimeout(() => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          top: scrollContainerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 500);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        padding: "0 22px",
        marginBottom: "50px",
      }}
    >
      <TextField
        placeholder={t("pages.chat.writeMessage")}
        fullWidth
        multiline
        rows={4}
        sx={{
          "& .MuiInputBase-root": {
            padding: "10px 14px",
            borderRadius: "8px !important",
          },
        }}
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        onKeyDown={handleKeyDown}
      />
      <Button
        onClick={handleSendMessage}
        variant="primary-sm"
        startIcon={currentLang === "en" ? <SendButtonIcon /> : <></>}
        endIcon={currentLang === "ar" ? <SendButtonIcon /> : <></>}
        sx={{ alignSelf: "flex-end" }}
      >
        {t("pages.chat.send")}
      </Button>
    </Box>
  );
};

export default ChatInput;
